'use es6';

import { combineReducers } from 'redux';
import Immutable from 'immutable';
import * as RequestStates from 'ecosystem-marketplace-core/constants/RequestState';
import * as ActionTypes from '../actions/ActionTypes';
const EMPTY_SET = Immutable.Set();
const EMPTY_UNUSED_FILTERS = Immutable.Map({
  unusedIndustries: Immutable.List(),
  unusedPageTypes: Immutable.List(),
  unusedPageFeatures: Immutable.List()
});

const searchTagsRequestState = (state = RequestStates.UNINITIALIZED, action) => {
  switch (action.type) {
    case ActionTypes.STOREFRONT_SEARCH_TAGS_REQUESTED:
      return RequestStates.PENDING;

    case ActionTypes.STOREFRONT_SEARCH_TAGS_RECEIVED:
      return RequestStates.SUCCEEDED;

    case ActionTypes.STOREFRONT_SEARCH_TAGS_FAILED:
      return RequestStates.FAILED;

    default:
      return state;
  }
};

const searchTagsData = (state = EMPTY_SET, action) => {
  switch (action.type) {
    case ActionTypes.STOREFRONT_SEARCH_TAGS_RECEIVED:
      return Immutable.Set(action.payload);

    default:
      return state;
  }
};

const unusedFiltersRequestState = (state = RequestStates.UNINITIALIZED, action) => {
  switch (action.type) {
    case ActionTypes.STOREFRONT_UNUSED_FILTERS_REQUESTED:
      return RequestStates.PENDING;

    case ActionTypes.STOREFRONT_UNUSED_FILTERS_RECEIVED:
      return RequestStates.SUCCEEDED;

    case ActionTypes.STOREFRONT_UNUSED_FILTERS_FAILED:
      return RequestStates.FAILED;

    default:
      return state;
  }
};

const unusedFiltersData = (state = EMPTY_UNUSED_FILTERS, action) => {
  switch (action.type) {
    case ActionTypes.STOREFRONT_UNUSED_FILTERS_RECEIVED:
      {
        let newState = state;
        Object.keys(action.payload).forEach(key => {
          newState = newState.set(key, Immutable.List(action.payload[key]));
        });
        return newState;
      }

    default:
      return state;
  }
};

export default combineReducers({
  searchTags: combineReducers({
    data: searchTagsData,
    requestState: searchTagsRequestState
  }),
  unusedFilters: combineReducers({
    data: unusedFiltersData,
    requestState: unusedFiltersRequestState
  })
});